import store from '@/store';
import router from './index';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { addHomeRouter, addRouter } from './add-router';
import { whiteList } from '@/config';
import { getQueryString } from '@/utils';
import getPageTitle from '@/utils/get-page-title';
import { _loginByUserName } from '@/utils/login';
import { getMenuTree, getMenus } from '@/api/home/index/api';

NProgress.configure({ showSpinner: false });

/**
 * 全局前置守卫
 * @param {Route} to 即将要进入的目标 路由对象
 * @param {Route} from 当前导航正要离开的路由
 * @param {Function} next
 */
router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    next();
    return;
  }

  const username = getQueryString('u');

  // 第三方系统嵌入
  if (username) {
    !store.state.isIframe && store.dispatch('setIsIframe', true);
    if (store.state.token) {
      if (to.query && !to.query.u) {
        to.query.u = username;
      }
      if (!store.state.menu.length) {
        getRouter(to, next);
      } else {
        next();
      }
    } else {
      _loginByUserName();
      next();
    }
  } else {
    store.state.isIframe && store.dispatch('setIsIframe', false);
    NProgress.start();
    document.title = getPageTitle(to.meta.title);

    // 首页菜单
    const { homeMenu } = store.state;
    if (homeMenu.length) {
      if (store.state.isLogout) {
        // 登录后退出
        store.dispatch('setLogout', false);
        addRoutes(addHomeRouter(homeMenu), to, next);
      }
    } else {
      getHomeRouter(to, next);
    }

    if (store.state.token) {
      // 登录后再进入登录页
      if (to.path === '/home/login') {
        next('/index');
      } else {
        if (!store.state.menu.length) {
          getRouter(to, next);
        } else {
          if (to.matched.length === 0) {
            // 登录重定向地址不存在
            if (from.path === '/home/login') {
              next('/index');
            } else {
              // 白名单
              if (whiteList.includes(to.path)) {
                next();
              } else {
                next('/404');
              }
            }
          } else {
            next();
          }
        }
      }
    } else {
      // 白名单
      if (whiteList.includes(to.path)) {
        next();
      } else {
        next('/home/login');
      }
      NProgress.done();
    }
  }
});

// 全局后置钩子
router.afterEach(() => {
  NProgress.done();
});

/**
 * 获取前台菜单
 * @param {Route} to 即将要进入的目标 路由对象
 * @param {Function} next
 */
function getHomeRouter(to, next) {
  getMenus()
    .then((res) => {
      const { code, data } = res;
      if (code === 0) {
        const asyncRouter = addHomeRouter(data);
        store.dispatch('setHomeMenu', data);
        return asyncRouter;
      }
    })
    .then((asyncRouter) => {
      addRoutes(asyncRouter, to, next);
    })
    .catch(() => {
      NProgress.done();
    });
}

/**
 * 获取后台路由
 * @param {Route} to 即将要进入的目标 路由对象
 * @param {Function} next
 */
function getRouter(to, next) {
  const { id, sSBaseId } = store.state.user;
  getMenuTree({
    userId: id,
    sSBaseId
  })
    .then((res) => {
      const { code, data } = res;
      if (code === 0) {
        // data.unshift({
        //   name: '首页',
        //   icon: 'el-icon-s-home',
        //   router: '/index',
        //   children: [
        //     {
        //       name: '首页',
        //       router: '/index/index'
        //     }
        //   ]
        // });
        const asyncRouter = addRouter(data);
        store.dispatch('setMenu', asyncRouter);
        return asyncRouter;
      }
    })
    .then((asyncRouter) => {
      addRoutes(asyncRouter, to, next);
    })
    .catch(() => {
      NProgress.done();
    });
}

/**
 * 动态添加路由
 * @param {Array} asyncRouter 路由列表
 * @param {Route} to 即将要进入的目标 路由对象
 * @param {Function} next
 */
function addRoutes(asyncRouter, to, next) {
  asyncRouter.forEach((route) => {
    // 动态新增可访问路由表
    router.addRoute(route);
  });
  next({ ...to, replace: true });
}
